import React, { useEffect, useState } from 'react';
import { useHistory, useNavigate, useLocation } from 'react-router-dom';
import useSetState from '../../hooks/useSetState';
import { useDispatch, useSelector } from 'react-redux';
import { loginByVerifyPhoneNumber } from '../../redux/login/actions';
import MyTimer from '../../hooks/MyTimer';
import { DeviceUUID } from 'device-uuid';
import ErrorModal from '../../component/ErrorModal';
import cookies from 'js-cookie';
import Loader from '../../component/Spin';
import { ArrowLeft2 } from 'iconsax-react';
import { AutoTabProvider } from 'react-auto-tab';

const EnterVerificatioCode = ({ ...props }) => {
  let history = useHistory();
  const [time, setTime] = useState('');

  const {
    loginByVerifyPhoneNumberMessage,
    sendVerificationCode,
    loginByVerifyPhoneNumberLoading,
  } = useSelector((state) => ({
    loginByVerifyPhoneNumberMessage:
      state.loginOrRegisterReducer.loginByVerifyPhoneNumberMessage,
    sendVerificationCode: state.loginOrRegisterReducer.sendVerificationCode,
    loginByVerifyPhoneNumberLoading:
      state.loginOrRegisterReducer.loginByVerifyPhoneNumberLoading,
  }));

  const [controls, setControls] = useSetState({
    mobileNumber: props.location.mobileNumber,
    deviceId: '',
    platform: 'PWA',
    fcmToken: '',
    verificationCodeDigitOne: '',
    verificationCodeDigitTwo: '',
    verificationCodeDigitThree: '',
    verificationCodeDigitFour: '',
    verificationCodeDigitFive: '',
  });

  const onChangeValue = (controleName, value) => {
    setControls({
      [controleName]: value,
    });
  };

  const dispatch = useDispatch();

  const onEditMobileNumber = () => {
    cookies.remove('login-timer');
    history.push('/login');
  };

  const onSubmitForm = (event) => {
    event.preventDefault();
    let fullVerificationcode = [
      controls.verificationCodeDigitOne,
      controls.verificationCodeDigitTwo,
      controls.verificationCodeDigitThree,
      controls.verificationCodeDigitFour,
      controls.verificationCodeDigitFive,
    ];

    let stringVerificationCode = fullVerificationcode.toString();
    let standardVerificationCode = stringVerificationCode.replace(/,/g, '');

    let data = {
      mobileNumber: controls.mobileNumber,
      deviceId: controls.deviceId,
      platform: controls.platform,
      fcmToken: controls.fcmToken,
      verificationCode: standardVerificationCode,
    };

    dispatch(loginByVerifyPhoneNumber(data)).then((res) => {
      let action = '';
      if (props.location.action) {
        action = props.location.action;
      } else {
        action = res.payload.action;
      }
      if (res.payload.cityCode !== '') {
        cookies.set('city-code', res.payload.cityCode);
      }

      let pathname;
      let introducedCafesFormRedirect = cookies.get(
        'introducedCafesFormRedirect',
      );
      let packagesPathname = cookies.get('packagesPathname');
      const cafePathname = cookies.get('cafePathname');

      if (introducedCafesFormRedirect) {
        pathname = introducedCafesFormRedirect;
      } else if (cafePathname) {
        pathname = cafePathname;
      } else if (packagesPathname) {
        pathname = packagesPathname;
      } else {
        pathname = '/';
      }

      history.push({
        pathname: pathname,
        authToken: res.payload.authToken,
        cityCode: res.payload.cityCode,
        action: action,
      });
    });
  };

  useEffect(() => {
    const uuid = new DeviceUUID().get();
    onChangeValue('deviceId', uuid.replaceAll('-', ''));

    let result = '';
    let characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < 180; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    onChangeValue('fcmToken', result);

    let timer;
    timer = cookies.get('login-timer');
    setTime(Number(timer));
  }, []);

  useEffect(() => {
    let timer;
    timer = cookies.get('login-timer');
    setTime(Number(timer));
  }, [sendVerificationCode]);

  return (
    <Loader spinning={loginByVerifyPhoneNumberLoading}>
      <div className='overflow-x-hidden scrollbar-hide md:w-1/2 lg:w-1/3 mx-auto my-5 relative h-screen'>
        <div className='flex justify-between items-center mt-10 mb-5'>
          <h1 className='text-2xl'>{locales('enter.verification.code')}</h1>
          <ArrowLeft2
            size='26'
            color='#03132F'
            onClick={() => onEditMobileNumber()}
          />
        </div>

        <div className='text-forthText text-md my-5'>
          <span>{locales('verification.code.for.mobile.number')}</span>
          <span className='font-semibold px-2'>
            {props.location.mobileNumber}
          </span>
          <span>{locales('code.has.sent')}</span>
        </div>

        <AutoTabProvider>
          <form
            id='registration'
            onSubmit={(event) => onSubmitForm(event)}
            className='flex justify-center text-lg'
            dir='ltr'
          >
            <input
              type='number'
              maxLength={1}
              tabbable
              pattern='\d*'
              required='true'
              value={controls.verificationCodeDigitOne}
              placeholder='-'
              className='text-center border border-lightBorder rounded-lg w-1/6 mx-0.5 py-3
                focus:border-secondary-100 focus:text-secondary-100 focus:outline-none'
              onChange={(event) =>
                onChangeValue('verificationCodeDigitOne', event.target.value)
              }
            />
            <input
              type='number'
              maxLength={1}
              tabbable
              pattern='\d*'
              required='true'
              value={controls.verificationCodeDigitTwo}
              placeholder='-'
              className='text-center border border-lightBorder rounded-lg w-1/6 mx-0.5 py-3
                focus:border-secondary-100 focus:text-secondary-100 focus:outline-none'
              onChange={(event) =>
                onChangeValue('verificationCodeDigitTwo', event.target.value)
              }
            />
            <input
              type='number'
              pattern='\d*'
              maxLength={1}
              tabbable
              required='true'
              value={controls.verificationCodeDigitThree}
              placeholder='-'
              className='text-center border border-lightBorder rounded-lg w-1/6 mx-0.5 py-3
                focus:border-secondary-100 focus:text-secondary-100 focus:outline-none'
              onChange={(event) =>
                onChangeValue('verificationCodeDigitThree', event.target.value)
              }
            />
            <input
              type='number'
              maxLength={1}
              tabbable
              pattern='\d*'
              required='true'
              value={controls.verificationCodeDigitFour}
              placeholder='-'
              className='text-center border border-lightBorder rounded-lg w-1/6 mx-0.5 py-3
                focus:border-secondary-100 focus:text-secondary-100 focus:outline-none'
              onChange={(event) =>
                onChangeValue('verificationCodeDigitFour', event.target.value)
              }
            />
            <input
              type='number'
              maxLength={1}
              tabbable
              pattern='\d*'
              required='true'
              value={controls.verificationCodeDigitFive}
              placeholder='-'
              className='text-center border border-lightBorder rounded-lg w-1/6 mx-0.5 py-3
                focus:border-secondary-100 focus:text-secondary-100 focus:outline-none'
              onChange={(event) =>
                onChangeValue('verificationCodeDigitFive', event.target.value)
              }
            />
          </form>
        </AutoTabProvider>

        <div className='flex justify-center align-middle mx-8 my-4' dir='ltr'>
          {time !== '' && (
            <MyTimer
              expiryTimestamp={time}
              mobileNumber={controls.mobileNumber}
            />
          )}
        </div>

        <div className='w-full flex justify-center absolute bottom-4 right-0'>
          <button
            type='submit'
            form='registration'
            className='large-button bg-primary-100 text-white text-md'
          >
            {locales('login')}
          </button>
          <ErrorModal errorMessage={loginByVerifyPhoneNumberMessage} />
        </div>
      </div>
    </Loader>
  );
};

export default EnterVerificatioCode;
